import { AccountOptions } from '@dev/ee-api/ee-api-models';
import { useSelector } from 'react-redux';
import { getGeneralInfo } from '@/store/account/actions';
import { getOnboardingSurveyStore } from '@/store/onboardingSurvey/actions';
import EmailMarketingSurvey2024 from '@/components/Surveys/OnboardingSurvey/config/marketing-2024v2.json';
import EmailMarketingSurvey2024v1 from '@/components/Surveys/OnboardingSurvey/config/marketing-2024.json';
import { getOnboardingStore } from '@/store/onboarding/actions';
import { OnboardingSurveyLoadingState } from '@/store/onboardingSurvey/types';

interface RequireOnboarding {
    isPossiblyRequired: boolean;
    isRequired: boolean;
    isLoading: boolean;
}

export const useRequireOnboarding = (): RequireOnboarding => {
    const { Options, IsSub } = useSelector(getGeneralInfo);
    const { isFinished } = useSelector(getOnboardingStore);
    const { completedFormData: surveyData, loaded: surveyLoaded } = useSelector(getOnboardingSurveyStore);
    const hasRightSurveyData = [EmailMarketingSurvey2024.formId,EmailMarketingSurvey2024v1.formId].includes(surveyData?.FormID);
    
    const isPossiblyRequired = !IsSub && Options?.includes(AccountOptions.RequireOnboardingProcess);
    const isRequired =
        !isFinished && isPossiblyRequired && surveyLoaded === OnboardingSurveyLoadingState.Loaded && hasRightSurveyData;

    return {
        isPossiblyRequired,
        isRequired,
        isLoading:
            isPossiblyRequired &&
            (surveyLoaded === OnboardingSurveyLoadingState.Default ||
                surveyLoaded === OnboardingSurveyLoadingState.Loading),
    };
};
